import { useState } from 'react';
import { Checkbox, Divider, Form, Space } from 'antd';
import { PersonForm, PERSON_ROLES } from '@shared/components/forms/PersonForm';
import { SelectClient, CREATE_CLIENT } from '@features/clients/components/SelectClient';

export const TakerStep = ({ form, beneficiaryForm, isBeneficiarySameAsTaker, onBeneficiarySameAsTakerChange, isExternal }) => {
  // Se habilita el formulario si es sesión externa, de lo contrario, se habilita al seleccionar un cliente
  const [isFormEnabled, setIsFormEnabled] = useState(isExternal);

  const handleClientChange = (value, option) => {
    setIsFormEnabled(true);

    if (value === CREATE_CLIENT) {
      form.resetFields();
      return;
    }

    // Si se selecciona un cliente se cargan los datos en el formulario
    form.setFieldsValue(option.record);
    form.validateFields();
  };

  return (
    <Space size={24} direction='vertical'>
      <PersonForm
        form={form}
        role={PERSON_ROLES.TAKER}
        showTitle={false}
        header={!isExternal && (<>
          <Form.Item label='Cliente'>
            <SelectClient onChange={handleClientChange} />
          </Form.Item>
          <Divider />
        </>)}
        footer={
          <Checkbox
            checked={isBeneficiarySameAsTaker}
            onChange={(e) => onBeneficiarySameAsTakerChange(e.target.checked)}
            disabled={!isFormEnabled}
          >
            El beneficiario es el mismo tomador
          </Checkbox>
        }
        disabled={!isFormEnabled}
      />
      {!isBeneficiarySameAsTaker && <PersonForm form={beneficiaryForm} role={PERSON_ROLES.BENEFICIARY} />}
    </Space>
  );
};